import {usePullRequestAnalyticsStore} from './PullRequestsAnalyticsStore'

export const useGetINPDiffTags = () => usePullRequestAnalyticsStore(s => s.getINPDiffTags)
